export function accordion() {
    const accordion = $(".accordion");
    const accordionItem = accordion.find(".accordion-item");
    const $window = $(window);
    let windowWidth = $window.innerWidth();
    
    accordionItem.on("click", function (e) {
        e.preventDefault();
        const $this = $(this);
        windowWidth = $window.innerWidth();

        if(windowWidth < 1024) {
            setTimeout(() => {
                const topPosition = $this.offset().top;
                $("html, body").stop().animate({scrollTop:topPosition}, 500, "swing");
            }, 500);
        }

        $this.toggleClass("active");
        $this.siblings().removeClass("active");
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js